//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import QRCode from 'qrcodejs2';
// import VueAwesomeSwiper from 'vue-awesome-swiper'
const { Swiper, SwiperSlide } = require('vue-awesome-swiper').default
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      qrcode: null,
      currentIdx: 0,
      lists: [
        { 
          key: 0, 
          name: '宝宝看图识物大全', 
          des: '学前百科知识 争做聪慧宝宝', 
          color: '#ffffff', 
          url: 'https://oss.idourl.com/upload/20210303/73bc1c2de47b4b418eee6ecc83d06391.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.idostudy.picture'
        },
        { 
          key: 1, 
          name: '儿童英文绘本故事', 
          des: '打好英文基础  做好英文启蒙', 
          color: '#ffffff', 
          url: 'https://oss.idourl.com/upload/20210303/d9f24d480b7e411bbffbbdfb39b20531.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.idostudy.enstory'
        },
        { 
          key: 2,
          name: '儿童国学启蒙大师', 
          des: '优质国学启蒙课程  领略国学文化精髓', 
          color: '#2D3644', 
          url: 'https://oss.idourl.com/upload/20210423/937b816641b2497bb7460147b2a412cc.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.idostudy.chinese'
        },
        { 
          key: 3,
          name: '幼儿数学思维启蒙', 
          des: '挖掘学习潜能  锻炼逻辑思维', 
          color: '#ffffff', 
          url: 'https://oss.idourl.com/upload/20210119/6e15244c27c548a6ad95f2050b8a7d71.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.qimeng.math'
        },
        { 
          key: 4, 
          name: '儿童绘本故事', 
          des: '实现孩子自主阅读第一步', 
          color: '#ffffff', 
          url: 'http://image.jiaofu.idobooker.com/picturestory/ce219fc9f85312941e9f05aa7f92e927.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.idostudy.picturebook'
        },
        { 
          key: 5, 
          name: '儿童早教思维训练', 
          des: '挖掘学习潜能  开启大脑发育', 
          color: '#ffffff', 
          url: 'https://oss.idourl.com/upload/20210105/529ba6bd371c1cdf85544a9c98c0534e.png',
          download: 'http://calculator.h5.idotools.com/#/teachingAssistantSeries/com.qimeng.naoli'
        }
      ],
      swiperOption: {
				//是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
				notNextTick: true,
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        centeredSlides: true,
        paginationClickable: true,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        spaceBetween: 30,
        onSlideChangeEnd: swiper => {
          //这个位置放swiper的回调方法
          this.currentIdx = swiper.realIndex;
          // this.qrcode.clear(); // 清除代码
          // this.qrcode.makeCode(this.lists[swiper.realIndex].url); // 生成另外一个二维码
        }
      }  
    }
  },
  //定义这个sweiper对象
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  methods: {
    returnBackground (idx) {
      return `background: url(${require(`../assets/images/jiaofu_${idx}.png`)}) no-repeat 0 0;background-size: 100% 100%;`
    },
    routerGoDownload (url) {
      window.location.href = url
    },
    clickSlideTo (i) {
      this.currentIdx = i;
      this.swiper.slideTo(i, 0, false);

      // this.qrcode.clear(); // 清除代码
      // this.qrcode.makeCode(this.lists[i].url); // 生成另外一个二维码
      // this.bindQRCode(this.lists[i].url)
    },
    bindQRCode (url) {
      this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: url,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    }
  },
  mounted () {
    //这边就可以使用swiper这个对象去使用swiper官网中的那些方法
    console.log('this.swiper', this.swiper)
    this.swiper.slideTo(0, 0, false);
    // this.bindQRCode(this.lists[0].url)
  }
}



// WEBPACK FOOTER //
// ./src/router/Home.vue